import React, { FunctionComponent, useEffect, useRef, RefObject } from 'react';
import classnames from 'classnames';
import { RecruitmentHeaderSp } from '../../molecules/recruitmentHeaderSp';
import { RecruitmentSearchForm } from '../../organisms/recruitmentSearchForm';
import { RecruitmentList } from '../../organisms/recruitmentList';
import type { Detail } from '../../atoms/recruitmentCheckBox/types';

type Props = {
  isBrandPage: boolean;
  fromFixed: any;
  isPage: string;
  isPc: boolean;
  chromeEdg: boolean;
  noimage: string;
  hoverIcon: string;
  isCompany: boolean;
  isStopped: boolean;
  dataCategory: any;
  dataValue: {
    recruitments?: string;
    recruitmentsScoutTag?: string;
    recruitmentsEntryTag?: string;
    recruitmentsNewTag?: string;
    recruitmentsPermanentTag?: string;
    recruitmentsActiveTag?: string;
    recruitmentsHiringTag?: string;
    recruitmentsAttentionTag?: string;
    recruitmentsAllTag?: string;
  };
  dataClickPoint: {
    company?: string;
    image?: string;
    title?: string;
  };
  company: any;
  cancelIcon: any;
  isSp: boolean;
  h1TitleState: string;
  page: number;
  isReleasedRecruitmentsNone: any;
  brandName: string;
  q: string;
  targetEmploymentTypes: any[];
  targetOccupationDetails: any[];
  targetPrefectureDetails: any[];
  targetPreferenceConditions?: any[];
  targetWorkingPeriods?: any[];
  preferenceConditionCategories?: any[];
  workingPeriodIds?: number[];
  salaryTypeIds?: number[];
  targetSalary?: { target_salary_type: string; target_salary_min: string; target_salary_max: string };
  handleChangeSalary?: (change: any) => void;
  releasedRecruitmentIds: number[];
  stoppedRecruitmentIds: number[];
  loading: boolean;
  targetCompanyIds: number[];
  recruitmentEmploymentTypes: any[];
  occupations: any[];
  occupationDetails: any[];
  welfares: any[];
  sidePrefectures: any[];
  allPrefectures: any[];
  detailPrefectures: any;
  targetOccupations: any[];
  targetPrefectures: any[];
  targetPrefectureNames: any[];
  occupationDetailsOccupationIds: any[];
  prefectureDetails: { [key: string]: Detail[] };
  spStyle: any;
  toggleStyle: any;
  toggleListStyle: any;
  popupStyle: any;
  modalStyle: any;
  handleChangeQ: (name: string, value: string) => void;
  handleSearch: (event: any) => void;
  handleOpenSp: () => void;
  onFirstLoad?: () => void;
  handlePaginateClick: (event: any) => void;
  handleClick: (event: any) => void;
  handleClearEmploymentTypes?: () => void;
  handleSelectAllEmploymentTypes?: () => void;
  handleClearOccupations?: () => void;
  handleSelectAllOccupations?: () => void;
  handleClearLocations?: () => void;
  handleSelectAllLocations?: () => void;
  handleClearAll?: () => void;
  handleClearAreas?: () => void;
  handleClearPrefectureDetails?: () => void;
  handleClearPreferenceConditions?: () => void;
  handleSelectAllPreferenceConditions?: () => void;
  handlePopup: () => void;
  handleModal: () => void;
  closePopup: () => void;
  handleFetchOccupationDetails: (occupationId: string, occupationDetailId: string) => void;
  handleFetchPrefectureDetails: (areaName: string, prefectureId: string) => void;
  checkAllOccupationDetails: (occupationId: string | number, checked: boolean, baseArray?: any[]) => void;
  checkAllPrefectureDetails: (array: any, areaName: string, checked: boolean) => void;
  openList: (event: any) => void;
  isShowingStoppedList: boolean;
  handleToggleStoppedList: () => void;
  hasAnyRecruitments: boolean;
  hasStoppedRecruitments: boolean;
  isShowAttentionPeople?: boolean;
  listRef?: RefObject<HTMLElement>;
};

export const Presentation: FunctionComponent<Props> = ({
  isBrandPage,
  fromFixed,
  isPage,
  isPc,
  chromeEdg,
  noimage,
  hoverIcon,
  isCompany,
  isStopped,
  dataCategory,
  dataValue,
  dataClickPoint,
  company,
  cancelIcon,
  isSp,
  h1TitleState,
  page,
  isReleasedRecruitmentsNone,
  brandName,
  q,
  targetEmploymentTypes,
  targetOccupationDetails,
  targetPrefectureDetails,
  targetPreferenceConditions,
  targetWorkingPeriods,
  preferenceConditionCategories,
  workingPeriodIds,
  salaryTypeIds,
  targetSalary,
  handleChangeSalary,
  releasedRecruitmentIds,
  stoppedRecruitmentIds,
  loading,
  targetCompanyIds,
  recruitmentEmploymentTypes,
  occupations,
  occupationDetails,
  welfares,
  sidePrefectures,
  allPrefectures,
  detailPrefectures,
  targetOccupations,
  targetPrefectures,
  targetPrefectureNames,
  occupationDetailsOccupationIds,
  prefectureDetails,
  spStyle,
  toggleStyle,
  toggleListStyle,
  popupStyle,
  modalStyle,
  handleChangeQ,
  handleSearch,
  handleOpenSp,
  onFirstLoad,
  handlePaginateClick,
  handleClick,
  handleClearEmploymentTypes,
  handleSelectAllEmploymentTypes,
  handleClearOccupations,
  handleSelectAllOccupations,
  handleClearLocations,
  handleSelectAllLocations,
  handleClearAll,
  handleClearAreas,
  handleClearPrefectureDetails,
  handleClearPreferenceConditions,
  handleSelectAllPreferenceConditions,
  handlePopup,
  handleModal,
  closePopup,
  handleFetchOccupationDetails,
  handleFetchPrefectureDetails,
  checkAllOccupationDetails,
  checkAllPrefectureDetails,
  openList,
  isShowingStoppedList,
  handleToggleStoppedList,
  hasAnyRecruitments,
  hasStoppedRecruitments,
  isShowAttentionPeople,
  listRef,
}) => {
  const recruitmentsCount = () => isShowingStoppedList
    ? stoppedRecruitmentIds.length
    : releasedRecruitmentIds.length;

  const isToggleDisabled = !hasStoppedRecruitments;

  const containerClass = isBrandPage
    ? 'l-articles l-articles--brand js-background-fixed'
    : 'l-articles js-background-fixed';

  const h1Ref = useRef<HTMLHeadingElement>(null);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (isBrandPage && h1Ref.current) {
      const offset = window.innerWidth >= 768 ? 80 : 16;
      const top = h1Ref.current.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'instant' as ScrollBehavior });
    }
  }, [page]);

  return (
    <div className={containerClass}>
      <div className="l-articles-inner u-clear">
        <h1 ref={h1Ref} className={`articles-title company ${isBrandPage ? 'brand' : ''}`}>
          {h1TitleState}
          {fromFixed && page !== 1 && `（${page}ページ目）`}
        </h1>
        {!isPc && (
          <RecruitmentHeaderSp
            isPage={isPage}
            isReleasedRecruitmentsNone={isReleasedRecruitmentsNone}
            q={q}
            targetEmploymentTypes={targetEmploymentTypes}
            targetOccupations={targetOccupations}
            targetOccupationDetails={targetOccupationDetails}
            occupationDetailsOccupationIds={occupationDetailsOccupationIds}
            targetPrefectureDetails={targetPrefectureDetails}
            handleChangeQ={handleChangeQ}
            handleSearch={handleSearch}
            handleOpenSp={handleOpenSp}
            handleModal={handleModal}
          />
        )}
        <main ref={listRef} className={`l-articles-main articles-container${!hasAnyRecruitments ? ' width' : ''}`} style={{ border: 'none' }}>
          <div className="articles-tab-count articles-tab-count--blank">
            <span>
              {recruitmentsCount() > page * 20 ? page * 20 : recruitmentsCount()} /{' '}
              <span className="articles-tab-count-text">{recruitmentsCount()}</span>
            </span>
            {hasAnyRecruitments && (
              <button
                onClick={handleToggleStoppedList}
                disabled={isToggleDisabled}
                className={classnames('recruitment-status-toggle', 'gtm-button-view-count', { 'is-disabled': isToggleDisabled })}
                data-event-name='button on screen'
                data-event='click'
                data-category={
                  isBrandPage
                    ? (isStopped ? dataCategory.stopBrandContent : dataCategory.brandContent)
                    : (isStopped ? dataCategory.stopCompanyRecruitmentList : dataCategory.companyRecruitmentList)
                }
                data-value='change_recruitments'
                data-state={isShowingStoppedList ? 'to_open' : 'to_close'}
              >
                <svg className="recruitment-status-toggle__icon" width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.93654 11L0 7.94745L2.93654 4.8949L3.54907 5.52494L1.64703 7.50195H6.56291V8.39295H1.64703L3.54907 10.3701L2.93654 11ZM9.06346 7.10528L8.45093 6.47523L10.353 4.49806H5.43709V3.60722H10.353L8.45093 1.63004L9.06346 1L12 4.05255L9.06346 7.10528Z" fill="currentColor"/>
                </svg>

                {isShowingStoppedList ? '募集中求人のみ表示' : '募集終了求人のみ表示'}
              </button>
            )}
          </div>
          <div className={classnames('recruitment-list-wrapper', { 'is-hide': isShowingStoppedList })}>
            {releasedRecruitmentIds.length !== 0 && (
              <RecruitmentList
                recruitment_ids={releasedRecruitmentIds}
                noimage={noimage}
                hoverIcon={hoverIcon}
                page={page}
                handlePaginateClick={handlePaginateClick}
                loading={loading}
                isPc={isPc}
                chromeEdg={chromeEdg}
                isCompany={isCompany}
                isBrandPage={isBrandPage}
                isStopped={isStopped}
                dataCategory={dataCategory}
                dataValue={dataValue}
                dataClickPoint={dataClickPoint}
                noCompanyIcon={''}
                isShowAttentionPeople={isShowAttentionPeople}
                onFirstLoad={onFirstLoad}
              />
            )}
          </div>
          <div className={classnames('recruitment-list-wrapper', { 'is-hide': !isShowingStoppedList })}>
            {stoppedRecruitmentIds.length !== 0 && (
              <RecruitmentList
                recruitment_ids={stoppedRecruitmentIds}
                noimage={noimage}
                hoverIcon={hoverIcon}
                page={page}
                handlePaginateClick={handlePaginateClick}
                loading={loading}
                isPc={isPc}
                chromeEdg={chromeEdg}
                isCompany={isCompany}
                isBrandPage={isBrandPage}
                isStopped={isStopped}
                dataCategory={dataCategory}
                dataValue={dataValue}
                dataClickPoint={dataClickPoint}
                noCompanyIcon={''}
                isShowAttentionPeople={isShowAttentionPeople}
              />
            )}
          </div>
          {!isBrandPage && !isShowingStoppedList && releasedRecruitmentIds.length === 0 && (
            <>
              <p className="articles-container--nothing--first">
                {company.name}は<br />
                求人公開準備中です。
              </p>
              <p className="articles-container--nothing--second">
                検索条件を変更するか
                <br />
                ページ上部より企業をフォローしてください。
              </p>
              <p className="articles-container--nothing">
                企業をフォローすると
                <br />
                求人が公開されたタイミングで通知が届きます。
              </p>
            </>
          )}
          {isBrandPage && !isShowingStoppedList && releasedRecruitmentIds.length === 0 && (
            <>
              <p className="articles-container--nothing--first">
                {brandName}の求人は<br/>
                公開準備中です。
              </p>
              <p className="articles-container--nothing">
                その他のブランドを見るには<br/>
                <a href="/brands" className='gtm-button-view-count' data-event-name='button on screen' data-event='click' data-category={dataCategory.stopBrandContent} data-value='empty'>ブランド一覧ページ</a>をご確認ください。
              </p>
            </>
          )}
        </main>
        <aside
          className={`search-form ${isSp && 'search-form__open'}`}
          style={{ ...toggleStyle, display: !hasAnyRecruitments ? 'none' : '', visibility: isSp ? 'visible' : 'initial' }}
        >
          <RecruitmentSearchForm
            isPage={isPage}
            isSp={isSp}
            q={q}
            recruitment_employment_types={recruitmentEmploymentTypes}
            occupations={occupations}
            occupation_details={occupationDetails}
            side_prefectures={sidePrefectures}
            all_prefectures={allPrefectures}
            detail_prefectures={detailPrefectures}
            target_employment_types={targetEmploymentTypes}
            target_occupations={targetOccupations}
            target_occupation_details={targetOccupationDetails}
            target_prefectures={targetPrefectures}
            target_prefecture_details={targetPrefectureDetails}
            target_preference_conditions={targetPreferenceConditions}
            target_working_periods={targetWorkingPeriods}
            preference_condition_categories={preferenceConditionCategories}
            working_period_ids={workingPeriodIds}
            salary_type_ids={salaryTypeIds}
            target_salary_type={targetSalary?.target_salary_type}
            target_salary_min={targetSalary?.target_salary_min}
            target_salary_max={targetSalary?.target_salary_max}
            handleChangeSalary={handleChangeSalary}
            handleClick={handleClick}
            handleClearEmploymentTypes={handleClearEmploymentTypes}
            handleSelectAllEmploymentTypes={handleSelectAllEmploymentTypes}
            handleClearOccupations={handleClearOccupations}
            handleSelectAllOccupations={handleSelectAllOccupations}
            handleClearLocations={handleClearLocations}
            handleSelectAllLocations={handleSelectAllLocations}
            handleClearAll={handleClearAll}
            handleClearAreas={handleClearAreas}
            handleClearPrefectureDetails={handleClearPrefectureDetails}
            handleClearPreferenceConditions={handleClearPreferenceConditions}
            handleSelectAllPreferenceConditions={handleSelectAllPreferenceConditions}
            handleSearch={handleSearch}
            handleChangeQ={handleChangeQ}
            handleFetchOccupationDetails={handleFetchOccupationDetails}
            handleFetchPrefectureDetails={handleFetchPrefectureDetails}
            checkAllOccupationDetails={checkAllOccupationDetails}
            checkAllPrefectureDetails={checkAllPrefectureDetails}
            occupationDetailsOccupationIds={occupationDetailsOccupationIds}
            recruitmentsCount={recruitmentsCount()}
            prefectureDetails={prefectureDetails}
            spStyle={spStyle}
            toggleListStyle={toggleListStyle}
            openList={openList}
            handlePopup={handlePopup}
            handleModal={handleModal}
            popupStyle={popupStyle}
            modalStyle={modalStyle}
            handleOpenSp={handleOpenSp}
            closePopup={closePopup}
            isPc={isPc}
            page={page}
          />
        </aside>
        <div className="search-form__popup--bg" style={spStyle} onClick={handleOpenSp}></div>
      </div>
    </div>
  );
};
